import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, startWith } from 'rxjs';

export interface SessionData {
  Signature: string;
  UserIp: string;
  Domains: string;
  SessionId: string;
  Environment?: string;
  Username?: string;
  DomainPermissions?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private sessionDataSubject = new BehaviorSubject<SessionData | null>(null);
  sessionData$ = this.sessionDataSubject.asObservable();

  get sessionData() {
    return this.sessionDataSubject.value;
  }

  constructor() {
    this.setupHeaders();
  }

  private getHeaders() {
    window.postMessage({ type: 'GetInitialReportData' }, '*');
    window.addEventListener('message', this.listener);
    window.postMessage(
        {
          type: 'SetInitialReportData',
          payload: {
            Signature:
              'fs5B5wRlb/xxw516:ut05ihk2HLH35MBSkwtjtgmMrvZzsGdy6N82u0DpXeMWlvagbEcsWB7eDtEuABcJ9re8QbSU9vky+5cQZTY3UZDJ6zsWiUNdkDbc5GRm97NFQiGHyaQUQZUj6ETQPU1FzqtQVWrKDvbpyEma68LTPncKHbvxJOfbB0rS6amaVfmsxRLcPyKEzatfjy3DODQPNsIUP7rDv4Dsx+I0sgruLmciHcYeXeXU1HtOeTYWsyxJ8vXaqvJfcWtNk6t9xEy8ayUYkMFHwgMMb6kQmobwznfNDpXGVyMc4SGBTMNfY85JlWLL14hUX1dfiuDi7bRTPNqKeVk2bwZJRLr5whH173xyu+WjQ6GKux9WSwSmCg==',
            UserIp: '127.0.0.1',
            Domains: 1000,
            Environment: 'localhost',
            Username: 'taras.maksymiv@everymatrix.com',
            DomainPermissions: [],
          },
        },
        '*'
      );
  }

  private listener = (e: any) => {
    if (e.data?.type === 'SetInitialReportData') {
      window.removeEventListener('message', this.listener);
      const payload = e.data.payload;
      const newSessionData: SessionData = {
        Signature: payload.Signature,
        SessionId: payload.SessionId,
        UserIp: payload.UserIp,
        Domains: payload.Domains || '1000',
        Environment: payload.Environment,
        Username: payload.Username,
        DomainPermissions: payload.DomainPermissions,
      };

      this.sessionDataSubject.next(newSessionData);
    }
  };

  setupHeaders() {
    // 1200000 = 20min;
    interval(1200000)
      .pipe(startWith(0))
      .subscribe(() => this.getHeaders());
  }
}
